import creativeApi from "@api/creatives" //eslint-disable-line
import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        loading: {
            creatives: false,
            creative: false,
            creativeSave: false,
        },
        errors: {
            creatives: null,
            creative: null,
            creativeSave: null,
        },
        rejectReasons: [],
        creatives: [],
        creative: {},
    },
    getters: {
        rejectReasons: state => state.rejectReasons,
        creatives: state => state.creatives,
        creative: state => state.creative,
        creativesReviewLoadingState: state => name => state.loading[name],
        creativesReviewErrorState: state => name => state.errors[name],
    },
    mutations: {
        setError(state, error) {
            Vue.set(state.errors, error.name, error.value)
        },
        setLoadingState(state, loading) {
            Vue.set(state.loading, loading.name, loading.value)
        },
        setRejectReasons(state, reasons) {
            Vue.set(state, 'rejectReasons', reasons)
        },
        creatives(state, creatives) {
            Vue.set(state, 'creatives', creatives)
        },
        creative(state, creative) {
            Vue.set(state, 'creative', creative)
        },
        updateCreativeProperty(state, payload) {
            Vue.set(state.creative, payload.property, payload.value)
        },
    },
    actions: {
        loadRejectReasons({ commit }) {
            commit('setLoadingState', { name: 'rejectReasons', value: true })

            creativeApi.getCreativeRejectReasons()
                .then(response => {
                    const { data } = response.data
                    commit('setRejectReasons', data)
                })
                .catch(() => {
                    commit('setError', { name: 'rejectReasons', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'rejectReasons', value: false })
                })
        },
        loadCreatives({ commit }) {
            commit('setLoadingState', { name: 'creatives', value: true })

            creativeApi.getCreativesForReview()
                .then(response => {
                    const { data } = response.data
                    commit('creatives', data)
                })
                .catch(() => {
                    commit('setError', { name: 'creatives', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'creatives', value: false })
                })
        },
        loadCreative({ commit }, uuid) {
            commit('setLoadingState', { name: 'creative', value: true })

            creativeApi.getCreative(uuid)
                .then(response => {
                    const { data } = response.data
                    commit('creative', data)
                })
                .catch(() => {
                    commit('setError', { name: 'creative', value: true })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'creative', value: false })
                })
        },
        updateCreative({ commit, state }) {
            commit('setLoadingState', { name: 'creativeSave', value: true })
            commit('setError', { name: 'creativeSave', value: false })

            return creativeApi.updateCreativeStatus(state.creative.uuid, state.creative)
                .catch(() => {
                    commit('setError', {
                        name: 'creativeSave',
                        value: true,
                    })
                })
                .finally(() => {
                    commit('setLoadingState', { name: 'creativeSave', value: false })
                })
        },
        updateCreativeProperty({ commit }, payload) {
            commit('updateCreativeProperty', payload)
        },
    },
}
